import {
  ContentSearchOptions,
  PhotoParams,
  ImageParams,
  LoadItemsFilter,
} from '../SearchInput.types';

import { SearchOptionNews } from './SearchOptionNews';
import { SearchOptionComment } from './SearchOptionComment';
import { SearchOptionLabel } from './SearchOptionLabel';
import { SearchOptionSurvey } from './SearchOptionSurvey';
import { SearchOptionSitesAll } from './SearchOptionSitesAll';
import { SearchOptionFilestorage } from './SearchOptionFilestorage';
import { SearchOptionEvent } from './SearchOptionEvent';
import { SearchOptionEmployee } from './SearchOptionEmployee';
import { SearchOptionCommunity } from './SearchOptionCommunity';
import { SearchOptionCommunityPost } from './SearchOptionCommunityPost';

interface SearchCommentOptionProps {
  option: ContentSearchOptions;
  loadPhoto: (params: PhotoParams) => Promise<Blob>;
  loadImage: (params: ImageParams) => Promise<string>;
  filter: LoadItemsFilter;
  onClose: () => void;
}

export const SearchOption = ({
  option,
  loadPhoto,
  loadImage,
  filter,
  onClose,
}: SearchCommentOptionProps) => {
  switch (option.type) {
    case 'label':
      return (
        <SearchOptionLabel option={option} filter={filter} onClose={onClose} />
      );
    case 'news':
      return <SearchOptionNews option={option} loadImage={loadImage} />;
    case 'comments':
      return <SearchOptionComment option={option} loadPhoto={loadPhoto} />;
    case 'employees':
      return <SearchOptionEmployee option={option} loadPhoto={loadPhoto} />;
    case 'communities':
      return <SearchOptionCommunity option={option} loadImage={loadImage} />;
    case 'community_posts':
      return (
        <SearchOptionCommunityPost option={option} loadImage={loadImage} />
      );
    case 'surveys':
      return <SearchOptionSurvey option={option} loadImage={loadImage} />;
    case 'sites_all':
      return <SearchOptionSitesAll option={option} />;
    case 'filestorages':
      return <SearchOptionFilestorage option={option} />;
    case 'events':
      return <SearchOptionEvent option={option} />;
    default:
      const exhaustiveCheck: never = option;

      return exhaustiveCheck;
  }
};
